import React from "react";
import { WebRouter } from "@intech/web-ui";

import { routes } from "./routes";
import { ThemeProvider } from "styled-components";
import theme from "./styles/theme";
import { AppProvider } from "@contexts";

export const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <AppProvider>
        <WebRouter hashRouter rotas={routes} />
      </AppProvider>
    </ThemeProvider>
  );
};
